<template>
  <v-dialog v-model="showDialog" max-width="650">
    <BaseTaskForm
      v-if="showDialog"
      :associated-records="associatedRecords"
      :collection-type="collectionType"
      :initial-type="initialType"
      :initial-marketing="marketing"
      :save-loading="saveLoading"
      @close="showDialog = false"
      @submit="submitHandler"
    />
  </v-dialog>
</template>

<script lang="ts">
import { defineComponent, PropType } from 'vue';

import { DialogMixin } from '@/bundles/Dialogs/mixins/DialogMixin';
import { taskService } from '@/bundles/Tasks/factories/taskServiceFactory';
import { ITaskCreateUpdatePayload } from '@/bundles/Tasks/interfaces/ITaskCreateUpdate';
import { TaskTypesEnum } from '@/bundles/Tasks/enums/TaskTypesEnum';
import { useNotifications } from '@/bundles/App/composables/useNotifications';

import BaseTaskForm from '@/bundles/Tasks/components/BaseTaskForm.vue';

interface ICreateTaskForm {
  saveLoading: boolean;
}

export default defineComponent({
  name: 'CreateTaskForm',

  components: { BaseTaskForm },
  mixins: [DialogMixin],

  props: {
    collectionType: {
      type: String,
      default: null
    },
    associatedRecords: {
      type: Array as PropType<any[]>, // todo: type this
      default: () => []
    },
    initialType: {
      type: String as PropType<TaskTypesEnum>,
      default: null
    },
    marketing: Boolean
  },

  emits: ['submit', 'refresh-activity'],

  setup () {
    const { addNotification, addSuccessNotification } = useNotifications();

    return { addNotification, addSuccessNotification };
  },

  data: (): ICreateTaskForm => ({
    saveLoading: false,
  }),

  methods: {
    async submitHandler (task: ITaskCreateUpdatePayload) {
      try {
        this.saveLoading = true;

        const newTask = await taskService.createTask(task);

        this.addSuccessNotification('Task created successfully.');
        this.$emit('submit', newTask);
        this.showDialog = false;
        this.$eventBus.$emit('refresh-activity', newTask._id);
      } catch (error: any) {
        this.addNotification({ ...error });
      } finally {
        this.saveLoading = false;
      }
    }
  }
});
</script>
